/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Empty } from '../../models/empty';

export interface PublishConfigsPublishConfigIdDelete$Params {

/**
 * A publish configuration id
 */
  publishConfigId: string;
  'Active-Tenant-Identifier': string;
}

export function publishConfigsPublishConfigIdDelete(http: HttpClient, rootUrl: string, params: PublishConfigsPublishConfigIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
  const rb = new RequestBuilder(rootUrl, publishConfigsPublishConfigIdDelete.PATH, 'delete');
  if (params) {
    rb.path('publishConfigId', params.publishConfigId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Empty>;
    })
  );
}

publishConfigsPublishConfigIdDelete.PATH = '/publish-configs/{publishConfigId}';
